import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\DocumentsController::__invoke
* @see app/Http/Controllers/Investors/DocumentsController.php:10
* @route '//app.finesthub.de/documents'
*/
const DocumentsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DocumentsController.url(options),
    method: 'get',
})

DocumentsController.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/documents',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\DocumentsController::__invoke
* @see app/Http/Controllers/Investors/DocumentsController.php:10
* @route '//app.finesthub.de/documents'
*/
DocumentsController.url = (options?: RouteQueryOptions) => {
    return DocumentsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\DocumentsController::__invoke
* @see app/Http/Controllers/Investors/DocumentsController.php:10
* @route '//app.finesthub.de/documents'
*/
DocumentsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DocumentsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\DocumentsController::__invoke
* @see app/Http/Controllers/Investors/DocumentsController.php:10
* @route '//app.finesthub.de/documents'
*/
DocumentsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: DocumentsController.url(options),
    method: 'head',
})

export default DocumentsController